export const parsePlatformSettingShortcodes = (payload: unknown): string[] => {
  if (!payload || typeof payload !== 'object') {
    return []
  }

  const shortcodes = (payload as {shortcodes?: unknown}).shortcodes
  if (!Array.isArray(shortcodes)) {
    return []
  }

  return shortcodes.filter(
    (item): item is string => typeof item === 'string' && item.trim().length > 0
  )
}

export const resolveFieldMappingShortcodeSettingName = (fieldMapping?: {
  field_code?: string | null
  api_code?: string | null
}): string => `${fieldMapping?.field_code ?? fieldMapping?.api_code ?? ''}`.trim()

export const shouldShowFieldMappingShortcodes = (fieldMapping?: {
  enable_shortcodes?: boolean
  input_type?: string | null
}): boolean =>
  Boolean(fieldMapping?.enable_shortcodes) &&
  ['TEXT', 'TEXTAREA'].includes(`${fieldMapping?.input_type ?? ''}`)
